export default "__VITE_ASSET__5c57ca16__"